/**
 * アラートダイアログ用定義
 */
const ALERT_DEF = {
  MESSAGE_WARNING: 'warning',
  MESSAGE_INFO: 'info',
  MESSAGE_SUCCESS: 'success',
  MESSAGE_DANGER: 'danger',
  MESSAGE_DEFAULT: 'default',
  DIALOG_TOAST: 'toast',
  DIALOG_CONFIRM: 'confirm',
  DIALOG_OK_CANCEL: 'ok-cancel',
  DIALOG_MULRIPLE: 'multiple',
  DIALOG_ALERT: 'alert',
  RESULT_YES: 'yes',
  RESULT_NO: 'no',
  RESULT_OK: 'ok',
  RESULT_CANCEL: 'cancel',
  TOAST_DISP_TIME: 3000,
}

/**
 * アラートダイアログ表示データ作成
 * @param {String} title     タイトル
 * @param {String} message   メッセージ
 * @param {String} msgType   メッセージタイプ
 * @param {String} dlgType   ダイアログタイプ
 * @param {String} keyFunc   戻り値判定機能名
 * @param {String} keyWord   戻り値判定キーワード
 * @param {Object} multi     マルチリターン定義
 * @param {Number} toastTime トースト表示時間
 */
function createAlertData(
  title,
  message,
  msgType,
  dlgType,
  keyFunc = null,
  keyWord = null,
  multi = {},
  toastTime = 3000
) {
  if (!title) {
    title = 'HRモンスター'
  }
  if (!message) {
    message = '確認してください。'
  }
  if (!msgType) {
    msgType = ALERT_DEF.MESSAGE_INFO
  }
  if (!dlgType) {
    dlgType = ALERT_DEF.DIALOG_TOAST
  }
  if (!keyFunc) {
    keyFunc = 'toast'
  }
  if (!keyWord) {
    keyWord = 'toast'
  }
  if (!multi.length < 0) {
    multi = {}
    dlgType = ALERT_DEF.DIALOG_TOAST
  }
  if (Number(toastTime) < 3000) {
    toastTime = 3000
  }

  // アラートダイアログ用データ設定
  const data = {
    // タイトル
    alertTitle: title,
    // メッセージ
    alertMessage: message,
    // メッセージタイプ
    alertMessageType: msgType,
    // ダイアログタイプ
    alertDialogType: dlgType,
    // 戻り値判定機能名
    alertKeyFunction: keyFunc,
    // 戻り値判定キーワード
    alertKeyWord: keyWord,
    // マルチリターン定義
    alertMultipleButton: multi,
    // トースト表示時間
    alertToastTime: Number(toastTime),
  }

  return data
}
export { ALERT_DEF, createAlertData }



// WEBPACK FOOTER //
// ./src/functions/common/alertFunc.js